import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito mucho tiempo para leer esto?',
    a: 'No, es una guía directa al grano diseñada para padres que tienen poco tiempo.'
  }, {
    q: '¿Funciona si mi pareja no está muy convencida?',
    a: 'Sí, muchos de los micro-momentos pueden ser iniciados por una sola persona y generan una respuesta positiva automática en el otro.'
  }, {
    q: '¿Es contenido erótico?',
    a: 'No, es una guía de reconexión emocional y física grounded en psicología y gestión de energía.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="px-6 py-10 bg-brand-light/5" data-id="element-41">
      <div className="max-w-3xl mx-auto" data-id="element-42">
        <motion.h3 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-4xl text-center text-brand-light mb-6" data-id="element-43">
          Preguntas <span className="text-brand-accent italic" data-id="element-44">Frecuentes</span>
        </motion.h3>

        <div className="space-y-4" data-id="element-45">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-brand-light/10 rounded-xl overflow-hidden bg-brand-dark" data-id="element-46">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-47">
                <span className="text-lg font-medium text-brand-light" data-id="element-48">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-accent transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-49" />
              </button>
              <AnimatePresence data-id="element-50">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-51">
                    <div className="px-6 pb-6 text-brand-light/70 font-light leading-relaxed" data-id="element-52">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}